import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-image-lightbox/style.css";
import fetchWrapper from "../../utils/fetch/fetchWrapper";
import Modal from "react-modal";

export default function Coments(){
    const [data, setData] = useState([]);
    const [selectedComment, setSelectedComment] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const fetchData = (event) => {
        fetchWrapper()
          .doGet({
              url: "/coments_admin",         
              onSuccess: async (response) => {
                  setData(response.data.data)
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
    }

    useEffect(()=>{
        fetchData()
    }, []);

    const handleCommentClick = (comment) => {
        setSelectedComment(comment);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setSelectedComment(null);
        setIsModalOpen(false);
    };
    const columns = [
        {
          name: 'Cliente',
          cell: (row) => <div>{`${row.name} ${row.lastname}`}</div>,
        },
        {
          name: "Email",
          selector: "email",
          sortable: true,
        },
        {
          name: "Numero de orden",
          selector: "order",
          sortable: true,
        },
        {
          name: "Evaluacion",
          sortable: true,
          cell: (row) => (
              <div
              style={{ cursor: "pointer", color: "blue" }}
              onClick={() => handleCommentClick(row.coment)}
              >
              Ver Evaluación
              </div>
            ),
        },
    ];

    const tableData = {
    columns,
    data
    };
      
    return (
        <>
          <DataTableExtensions {...tableData}>    
            <DataTable
              columns={columns}
              data={data}
              pagination
              paginationPerPage={10}
            />
          </DataTableExtensions>    
          <Modal
            isOpen={isModalOpen}
            onRequestClose={closeModal}
            contentLabel="Evaluación"
            style={customModalStyles}
          >
            <h2>Evaluación</h2>
            <p>{selectedComment}</p>
            <button onClick={closeModal}>Cerrar</button>
          </Modal>
        </>
    );
}
const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "60%", // Cambia el tamaño del modal según tus necesidades
      maxHeight: "80vh", // Altura máxima del modal
      overflowY: "auto", // Añade un desplazamiento vertical si el contenido es demasiado largo
    },
  };